import React from 'react';
import {getErrorText} from '../../lib/Utils';
import SkWave from '../SkWave';

import 'spinkit/css/spinkit.css';

export default class Waitable extends React.Component {


  render() {
    let { entities, children, style} = this.props;
    let isLoading = false;
    let error = false;
    let errorText = false;

    if (entities) {
      for(let i = 0; i< entities.length; i++){
        isLoading = entities[i].get("isFetching");  
        let object = entities[i].toObject();        
        error = object.error;
        if (error && object) {
          errorText = getErrorText(this.props.errorText, object.error);       
        }
        if(isLoading) break;
      }
      
    }
 

    return (<div className="animated">     
      {isLoading ?   <SkWave style={style}/> 
      : <div style={style}> {children} </div> }
    </div>);
  }

}


// WEBPACK FOOTER //
// ./src/components/Waitable/Waitable.js